/**
 * 流程节点：和以下流程节点匹配为 "待供应商上传/采购经理上传" 节点
 */
export const pendingSupplierUploadNodeCodes = [
  "4c672d49-af1b-41f2-b087-80e315523bc7", // 合同上传方（澳美）供应商、申请人提交合同
  "4436beff-2b41-4f98-be3c-83cde2f9c23c", // 合同上传方（供应商）采购经理上传提交合同
];

/** 流程节点：和以下流程节点匹配为 "确认合同" 节点 */
export const confirmContractNodeCodes = [
  "dc40898c-defc-41e3-b895-064e9dad7c26", // 合同上传方（澳美）确认合同
  "a55a19bd-a482-4f2b-9eae-63f204d0776e", // 合同上传方（供应商）确认合同
];

/** 流程节点：和以下流程节点匹配为 "供应商发起申请第一次审批（采购经理）" 节点 */
export const supplierContractUploadShouldApplyNodeCodes = ["submit"];
